import React, { Component, ErrorInfo } from 'react';
import FormattedMessageWrapper from '~/components/views/FormattedMessageWrapper/FormattedMessageWrapper';
import PrimaryButton from '~/components/views/common/buttons/PrimaryButton/PrimaryButton';
import './AppErrorBoundary.pcss';

interface Props {
  children?: React.ReactNode;
  error?: Error | null;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

class AppErrorBoundary extends Component<Props, State> {
  state = {
    hasError: false,
    error: null,
    errorInfo: null,
  };

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({
      hasError: true,
      error,
      errorInfo,
    });
  }

  onReloadClick = () => {
    globalThis.location.reload();
  };

  render() {
    const error = this.state.error ?? this.props.error;

    if (!error && this.props.children) {
      return this.props.children;
    }

    return (
      <div className="AppErrorBoundary">
        <div className="error-boundary-wrapper">
          <span className="error-header">
            <FormattedMessageWrapper langKey="web.app_error_boundary.header" />
          </span>

          <span className="error-message">
            <FormattedMessageWrapper langKey="web.app_error_boundary.messages.not_too_much_trouble" />
            <FormattedMessageWrapper
              langKey="web.app_error_boundary.messages.press_reload_page"
              values={{
                reloadButtonText: (
                  <span className="uppercase">
                    <FormattedMessageWrapper langKey="web.app_error_boundary.button.reload_page" />
                  </span>
                ),
              }}
            />
            {/*<FormattedMessageWrapper langKey="web.app_error_boundary.messages.if_error_persists" />*/}
          </span>

          <PrimaryButton
            onClick={this.onReloadClick}
            langKey="web.app_error_boundary.button.reload_page"
            className="uppercase"
          />
        </div>
      </div>
    );
  }
}

export default AppErrorBoundary;
